//---------------------
// 회원
//---------------------
const userRouter = [
  {
    // Legacy: 서비스 별로 본인인증 페이지 분기하기 전 디폴트 페이지.
    path: "/user/verifications/kcb/result",
    name: "user-verifications-kcb-result",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    // 임시: null로 떨어지는 경우가 있어서 추가.
    path: "/user/verifications/kcb/result/null",
    name: "user-verifications-kcb-result/null",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/user/verifications/kcb/result/insurance/:seqs",
    name: "user-verifications-kcb-result-insurance",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/user/verifications/kcb/result/lotte",
    name: "user-verifications-kcb-result",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  // 같은 페이지인데 집주인/공인중개사 요청 여부에 따라 경로가 달라져서 중복 정의.
  {
    path: "/user/verifications/kcb/result/credit_tenant/owner/:encoded_report_seq",
    name: "user-verifications-kcb-result-credit-tenant-owner",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultCreditTenantView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/user/verifications/kcb/result/credit_tenant/realtor/:encoded_report_seq",
    name: "user-verifications-kcb-result-credit-tenant-realtor",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultCreditTenantView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  // 집주인 본인인증 결과 페이지.
  {
    path: "/user/verifications/kcb/result/credit_owner/:encoded_owner_agreement_seq",
    name: "user-verifications-kcb-result-credit-owner",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultCreditOwnerView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  //태풍 게스트 본인인증 결과 페이지
  {
    path: "/user/verifications/kcb/result/credit_guest/typhoon/:encoded_owner_agreement_seq",
    name: "user-verifications-kcb-result-credit-guest-typhoon",
    component: () =>
      import("../views/user/verify/kcb/typhoon/UserVerifyKcbResultCreditTyphoonGuestView.vue"),
  },
  // 직거래 본인인증 결과 페이지
  {
    path: "/user/verifications/kcb/result/direct_deal/:direct_deal_seq",
    name: "user-verifications-kcb-result-direct-deal",
    component: () => import("../views/user/verify/kcb/UserVerifyKcbResultDirectDealView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  // 직거래 동의 본인인증 결과 페이지 (상대방 플로우)
  {
    path: "/user/verifications/kcb/result/direct_deal_consent/:direct_deal_seq/:party_seq",
    name: "user-verifications-kcb-result-direct-deal-consent",
    component: () =>
      import("../views/user/verify/kcb/UserVerifyKcbResultDirectDealConsentView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
];

export default userRouter;
